export const VIRTUAL_STATION_START_POLLING = 'START_POLLING';
export const VIRTUAL_STATION_STOP_POLLING = 'STOP_POLLING';
export const VIRTUAL_STATION_UPDATE_POLLING_STATUS = 'UPDATE_POLLING_STATUS';
export const VIRTUAL_STATION_START_COUNTDOWN = 'START_COUNTDOWN';
export const VIRTUAL_STATION_STOP_COUNTDOWN = 'STOP_COUNTDOWN';
export const VIRTUAL_STATION_SET_LOADING = 'SET_LOADING';
export const VIRTUAL_STATION_SCAN_SUCCESS = 'SCAN_SUCCESS';
export const VIRTUAL_STATION_SCAN_ERROR = 'SCAN_ERROR';
export const VIRTUAL_STATION_SET_OPEN_QR_SCANNER = 'SET_OPEN_QR_SCANNER';

export const startPolling = () => ({
  type: VIRTUAL_STATION_START_POLLING
});

export const stopPolling = () => ({
  type: VIRTUAL_STATION_STOP_POLLING
});

export const startCountdown = (seconds) => ({
  type: VIRTUAL_STATION_START_COUNTDOWN,
  payload: seconds
});

export const stopCountdown = () => ({
  type: VIRTUAL_STATION_STOP_COUNTDOWN,
  payload: 30 // Reset to initial value
});

export const setLoading = (isLoading) => ({
  type: VIRTUAL_STATION_SET_LOADING,
  payload: isLoading
});

export const scanSuccess = (data) => ({
  type: VIRTUAL_STATION_SCAN_SUCCESS,
  payload: data
});

export const scanError = (error) => ({
  type: VIRTUAL_STATION_SCAN_ERROR,
 payload: error
});

export const setOpenQrScanner = (open) => ({
  type: VIRTUAL_STATION_SET_OPEN_QR_SCANNER,
  payload: open
});
